import { Block } from '@/components/block';
import { DappModuleDataType } from '@/types/home';
import { useHomeStore } from '@/store/home';
import { DAppCard } from './dappCard';
import styles from './index.module.scss';
import { Tabs } from '@bfe/moly';
import { useState } from 'react';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';
import cls from 'classnames';
import 'swiper/css';
import 'swiper/css/grid';
import { Grid } from 'swiper/modules';
import { useFm, useScreenType } from '@web3/base-hooks';
import { scTrack } from '@web3/base-tracking';
import { Event, Page } from '@/config/track-config';

export const ExploreDApps = () => {
  const fm = useFm();
  const { dapps } = useHomeStore();
  const [mainSwiper, setMainSwiper] = useState<SwiperClass>();
  const [dict, setDict] = useState<'prev' | 'next'>('next');
  const [isEnd, setIsEnd] = useState(false);
  const [isBeginning, setisBeginning] = useState(false);
  const { isMobile } = useScreenType();

  const dappCategoryWithList = dapps.map((item: DappModuleDataType) => {
    return {
      category: item.moduleName,
      sequence: item.sequence,
      dapps: item.dappData.data.map((dapp) => {
        return {
          dappId: dapp.dappId,
          name: dapp.name,
          logo: dapp.logo,
          website: dapp.website,
          description: dapp.description,
        };
      }),
    };
  });

  const onSwiperNext = () => {
    setDict('next');
    if (!mainSwiper?.isEnd) {
      // 检查是否已经到达最后一页
      mainSwiper?.slideNext();
    } else {
      // console.log('已经到达最后一页');
    }
  };

  const onSwiperPrev = () => {
    setDict('prev');
    if (!mainSwiper?.isBeginning) {
      // 检查是否已经到达第一页
      mainSwiper?.slidePrev();
    } else {
      // console.log('已经到达第一页');
    }
  };

  const items = dappCategoryWithList.map((tab) => {
    // 接口返回3个
    // mock9个，一共12个
    // for (let index = 0; index < 2; index++) {
    //   tab.dapps.push(...tab.dapps);
    // }

    const swiperOptions = {
      grid: {
        rows: isMobile
          ? tab.dapps.length > 2
            ? 2
            : 1
          : tab.dapps.length > 8
            ? 2
            : 1,
        fill: 'row',
      },
      slidesPerGroup: isMobile ? 2 : 4,
      spaceBetween: isMobile ? 20 : 24,
    };

    const displayPagination = isMobile
      ? tab.dapps.length > 4
      : tab.dapps.length > 5;

    return {
      key: String(tab.sequence),
      label: <div className="key">{tab.category}</div>,
      children: (
        <div className={styles.dapp_container}>
          {displayPagination ? (
            <div
              className={cls('swper-custom-prev', {
                'swper-custom-disable': dict === 'prev' && isBeginning,
              })}
              onClick={onSwiperPrev}
            ></div>
          ) : null}
          {displayPagination ? (
            <div
              className={cls('swper-custom-next', {
                'swper-custom-disable': dict === 'next' && isEnd,
              })}
              onClick={onSwiperNext}
            ></div>
          ) : null}

          <Swiper
            onSwiper={setMainSwiper}
            onSlideChange={(swiper) => {
              setIsEnd(swiper.isEnd);
              setisBeginning(swiper.isBeginning);
            }}
            slidesPerView="auto"
            grid={swiperOptions.grid as any}
            slidesPerGroup={swiperOptions.slidesPerGroup}
            spaceBetween={swiperOptions.spaceBetween}
            className="mySwiper"
            modules={[Grid]}
          >
            {tab.dapps.map((item) => (
              <SwiperSlide key={item.dappId} style={{ width: 'auto' }}>
                <DAppCard key={String(item.dappId)} {...item} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ),
    };
  });

  const isEmpty = !dapps || dapps.length === 0;

  if (isEmpty) {
    return null;
  }

  return (
    <Block clsName={styles.exploreDAppsWrapper} noHeader>
      <div className={styles.exploreDApps}>
        <div className={styles.exploreDApps_head}>{fm('exporeDApps')}</div>
        <div className={styles.exploreDApps_body}>
          <Tabs
            size={isMobile ? 'm' : 'l'}
            items={items}
            className={styles.exploreDApps_body__tabs}
            defaultActiveKey="1"
            onChange={(key) => {
              scTrack(Event.Web3UserClick, {
                page_name: Page.Home,
                area: 'ExploreDApps',
                button_name: 'Tab',
                params: key,
              });
            }}
          />
        </div>
      </div>
    </Block>
  );
};
